import React from 'react';
import { useSmallScreen } from 'utils/hooks';
import { Box, Typography, IconButton } from '@mui/material';
import * as icons from 'mdi-material-ui';

const DocumentLine = props => {
    const { doc, onDelete } = props;
    const isSmall = useSmallScreen();

    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent={isSmall ? 'space-between' : 'normal'}
        >
            <Typography sx={{ fontSize: 14, color: 'primary.main' }}>{doc.name}</Typography>
            <IconButton size="small" disableRipple onClick={onDelete}>
                <icons.Delete />
            </IconButton>
        </Box>
    );
};

export default DocumentLine;
